import stores from '../../stores'

const resetAllStores = () => {
    stores.giftcardStore.reset();
    stores.identityStore.reset();
    stores.plaidStore.reset();
    stores.walletStore.reset();
}

export { resetAllStores }